var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-158 -240)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(168.071 243) rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.053,
    height: 10,
    rx: 0.526,
    transform: "translate(4.474 0)",
    fill: "#d34d1b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.053,
    height: 10,
    rx: 0.526,
    transform: "translate(10 4.474) rotate(90)",
    fill: "#d34d1b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(158 240)",
    fill: "none",
    stroke: "#162055",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 3.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.418ac3072a8566af522c2fbb149d528f.svg";
export { ForwardRef as ReactComponent };